/**
 * VNode helper
 */
export default {
  name: 'van-node',
  functional: true,
  props: {
    node: Array
  },
  render: function render(h, ctx) {
    return ctx.props.node;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.1.4@vant/es/utils/node.js
// module id = null
// module chunks = 